import { render, staticRenderFns } from "./InCaseMenu.vue?vue&type=template&id=0becbc5e&scoped=true"
import script from "./InCaseMenu.vue?vue&type=script&lang=js"
export * from "./InCaseMenu.vue?vue&type=script&lang=js"
import style0 from "./InCaseMenu.vue?vue&type=style&index=0&id=0becbc5e&prod&lang=css"
import style1 from "./InCaseMenu.vue?vue&type=style&index=1&id=0becbc5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becbc5e",
  null
  
)

export default component.exports